<template lang="pug">
  v-app-bar(
    app
    dense
    flat
    v-if="visible"
    :value="true"
  )
    .v-toolbar-icons
      v-btn(fab small text @click="onClick()")
        v-icon menu
    v-spacer
    v-avatar(color="grey")
      v-img(:src="avatar")
    span.ml-2
      | {{ displayName }}
    v-btn.ml-2(fab small text)
      v-icon settings
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      'visible': 'toolbar/isVisible',
      'displayName': 'user/name',
      'avatar': 'user/avatar'
    })
  },
  methods: {
    onClick () {
      this.$store.dispatch('navigation/toggleSize')
    }
  }
}
</script>

<style lang="stylus" scoped>
$TOOLBAR_ELE_WIDTH = 34px
$TOOLBAR_ELE_HEIGHT = 34px

.v-app-bar
  >>> .v-toolbar__content
    height: 49px !important
    border-bottom: 1px solid rgba(#000, 0.12)

  >>> .v-toolbar-icons
    .v-btn
      height: $TOOLBAR_ELE_HEIGHT !important
      margin: 0 6px

      &--fab
        width: $TOOLBAR_ELE_WIDTH !important

      &:first-child
        margin-left: 0

      &:last-child
        margin-right: 0

  >>> .v-avatar
    width: $TOOLBAR_ELE_WIDTH !important
    height: $TOOLBAR_ELE_HEIGHT !important
    min-width: auto !important
</style>
